import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { Tooltip } from "../tooltip";
import { useConfig } from "../_util/config-context";
import { Copy } from "../copy";
function TextRaw(props, ref) {
    var _a;
    var classPrefix = useConfig().classPrefix;
    var parent = props.parent, align = props.align, verticalAlign = props.verticalAlign, overflow = props.overflow, nowrap = props.nowrap, underline = props.underline, tooltip = props.tooltip, className = props.className, style = props.style, theme = props.theme, bgTheme = props.bgTheme, float = props.float, reset = props.reset, copyable = props.copyable, htmlProps = __rest(props, ["parent", "align", "verticalAlign", "overflow", "nowrap", "underline", "tooltip", "className", "style", "theme", "bgTheme", "float", "reset", "copyable"]);
    var rawChildren = props.children;
    var children = rawChildren;
    if (copyable && !overflow) {
        var copyProps = typeof copyable === "object" ? copyable : {};
        children = (React.createElement(React.Fragment, null,
            children,
            " ",
            React.createElement(Copy, __assign({ text: children }, copyProps))));
    }
    var element = React.createElement(parent || "span", __assign({ ref: ref, className: classNames(className, (_a = {},
            _a[classPrefix + "-bg-" + bgTheme] = bgTheme,
            _a[classPrefix + "-text"] = theme === "text",
            _a[classPrefix + "-text-" + theme] = theme && theme !== "text",
            _a[classPrefix + "-text-" + align] = align,
            _a[classPrefix + "-align-" + verticalAlign] = verticalAlign,
            _a[classPrefix + "-text-overflow"] = overflow,
            _a[classPrefix + "-text-nowrap"] = nowrap,
            _a[classPrefix + "-text-underline"] = underline,
            _a[classPrefix + "-float-" + float] = float && float !== "clear",
            _a[classPrefix + "-fz-reset"] = reset,
            _a["clearfix"] = float === "clear",
            _a)), style: style }, htmlProps), children);
    if (copyable && overflow) {
        var copyProps = typeof copyable === "object" ? copyable : {};
        element = React.createElement(parent || "span", {
            style: { display: "flex" },
        }, React.createElement(React.Fragment, null,
            element,
            React.createElement("span", { style: { flexShrink: 0 } },
                React.createElement(Copy, __assign({ text: children }, copyProps)))));
    }
    // 提供快捷 tooltip 使用方式
    if (tooltip) {
        var title = typeof tooltip === "boolean" ? rawChildren : tooltip;
        element = React.createElement(Tooltip, { title: title }, element);
    }
    return element;
}
export var Text = forwardRef(TextRaw);
Text.displayName = "Text";
//# sourceMappingURL=Text.js.map